import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import './OldBloodTest.scss';
import OldBloodTestTable from './OldBloodTestTable';
import UploadModal from './UploadModal';

const OldBloodTest: React.FC = () => {
  const [totalCount, setTotalCount] = useState<number>(0);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState<boolean>(false);
  const [refreshKey, setRefreshKey] = useState<number>(0);
  const assigned_doctor = JSON.parse(sessionStorage.getItem("assigned_doctor") ?? "false");
  const {admin: { role }} = useSelector((state: RootState) => state.admin);
  const isReadOnly = role === "doctor" && !assigned_doctor;

  const handleUploadClick = () => {
    setIsUploadModalOpen(true);
  };

  const handleUploadSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="old-blood-test">
      <div className="old-blood-test-header sideBarPad2">
        <h2 className="old-blood-test-title">Old Blood Tests ({totalCount})</h2>
        {!isReadOnly && (
          <button 
            className="upload-button" 
            onClick={handleUploadClick}
          >
            <span className="upload-icon">+</span>
            Upload
          </button>
        )}
      </div>
      <div className="old-blood-test-container">
        <OldBloodTestTable key={refreshKey} onCountUpdate={setTotalCount} />
      </div>
      
      <UploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        onUploadSuccess={handleUploadSuccess}
      />
    </div>
  );
};

export default OldBloodTest;
